import React, { useState } from "react";
import styles from "./Summary.module.css";
import { Box, Button, Grid, Menu, MenuItem } from "@mui/material";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  Link,
  KeyboardArrowDown,
  DrawOutlined,
  EditNoteOutlined,
  FileDownloadOutlined,
  DeleteOutlineOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
const Summary = () => {
  const contractValue = [
    { key: "Contract Number", value: "CONT#010" },
    { key: "Start Date", value: "Mon 07 Oct 2024" },
    { key: "End Date", value: "Mon 24 Mar 2025" },
    { key: "Contract Type", value: "Statement of work" },
  ];
  const [invoiceValue, setInvoiceValue] = useState(null);
  const [invoiceStatus, setInvoiceStatus] = useState(null);
  const [anchorEl1, setAnchorEl1] = useState(null);
  const navigate = useNavigate();
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const handleClose = () => {
    navigate("/work/contracts");
  };

  const handleDownload = () => {
    const element = document.getElementById("contract-section"); // Target the specific section

    if (!element) {
      console.error("Element not found");
      return;
    }

    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      // Define margins
      const margin = 10; // 10mm on each side
      const contentWidth = pdfWidth - 2 * margin; // Adjusted content width
      const contentHeight = (canvas.height * contentWidth) / canvas.width;

      // Add the image with margins
      pdf.addImage(imgData, "PNG", margin, 10, contentWidth, contentHeight);
      pdf.save("contract-section.pdf");
      handleClose1();
    });
  };

  return (
    <>
      <div id="contract-section">
        <div className={styles.top}>
          <img src="/mainfavicon.png" alt="Road Pilot" className={styles.img} />
          <div>CONTRACT</div>
        </div>
        <div className={styles.midFile}>
          <h1>
            Road Pilot Pvt. Ltd
            <br /> New Grora, Lucknow, UP
          </h1>
          <div className={styles.contractFile}>
            {contractValue.map((item) => (
              <div className={styles.keyValue}>
                <span className={styles.contFile}>{item.key}</span>{" "}
                <span className={styles.contFileTwo}>{item.value}</span>
              </div>
            ))}
          </div>
        </div>
        <h1>
          Client <br />
          Brayan Gutkowski
          <br />
          Rosenbaum Inc
          <br />
          452 Nikko Parkways Suite 598
          <br />
          North Tyrelshire, MS 84344-1322
        </h1>
        <div>
          <h1 className={styles.subject}>Subject</h1>
          <p>I ask! It's always.</p>
        </div>
        <div>
          <h1 className={styles.notes}>Notes</h1>
          <p></p>
        </div>
        <div>
          <h1 className={styles.description}>Description</h1>
          <p>
            On which Seven looked up and leave the room, when her eye fell upon
            a Gryphon, lying fast asleep in the sea, some children digging in
            the schoolroom, and though this was his first speech. 'You should
            learn not to lie down on one knee as he spoke, and added 'It isn't
            directed at all,' said Alice.
          </p>
        </div>
        {/* <hr style={{ color: "gray" }} /> */}
        <div>
          <h1 className={styles.contract}>Contract Value: $403.00</h1>
        </div>
      </div>
      <hr style={{ color: "gray" }} />
      <Grid container sx={{ padding: "10px 0 20px 0" }}>
        <Grid item xs={11} className="messageFooter">
          <Box>
            <Button
              id="basic-button"
              aria-controls={open1 ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open1 ? "true" : undefined}
              onClick={handleClick1}
              className="response"
              endIcon={<KeyboardArrowDown />}
              sx={{
                width: "120%",
                height: "100%",
                color: "#fff",
                bgcolor: "#1d82f5",
                "&:hover": {
                  bgcolor: "orange",
                },
              }}
            >
              Save
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl1}
              open={open1}
              onClose={handleClose1}
              sx={{ zIndex: 3000 }}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem
                value="closed"
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => {
                  setInvoiceStatus(1);
                  setInvoiceValue(0);
                }}
              >
                <Link /> &nbsp; Public Link
              </MenuItem>
              <MenuItem
                value="open"
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => {
                  setInvoiceStatus(2);
                  setInvoiceValue(0);
                }}
              >
                {" "}
                <DrawOutlined /> &nbsp; Company Signature
              </MenuItem>
              <MenuItem
                value="pending"
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => {
                  setInvoiceStatus(3);
                  setInvoiceValue(0);
                }}
              >
                {" "}
                <EditNoteOutlined /> &nbsp; Edit
              </MenuItem>
              <MenuItem
                value="resolved"
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={handleDownload}
              >
                {" "}
                <FileDownloadOutlined /> &nbsp; Download
              </MenuItem>
              <MenuItem
                value="resolved"
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => {
                  setInvoiceStatus(4);
                  setInvoiceValue(1);
                }}
              >
                {" "}
                <DeleteOutlineOutlined /> &nbsp; Delete
              </MenuItem>
            </Menu>
          </Box>
          <Box className="cancel" onClick={handleClose}>
            Cancel
          </Box>
        </Grid>
      </Grid>{" "}
    </>
  );
};

export default Summary;
